export class NamedSoftwareVersion {
    name: string;
    version: string;

    constructor(name: string, version: string) {
        this.name = name;
        this.version = version;
    }
}

export function IsNamedSoftwareVersion(obj: any): boolean {
    if (obj == null) return false;
    let targetProps = Object.keys(new NamedSoftwareVersion(null, null));
    let objProps = Object.keys(obj);
    if (targetProps.length != objProps.length) return false;
    for (const targetProp of targetProps) {
        if (objProps.indexOf(targetProp) < 0) return false;
    }
    for (const objProp of objProps) {
        if (targetProps.indexOf(objProp) < 0) return false;
    }
    return true;
}
